import { Injectable } from '@angular/core';
import { Http, Headers, BaseRequestOptions, RequestOptions, RequestMethod, Jsonp, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise'
import { Subject } from 'rxjs/Subject'

//Providers
import { ConfigProvider } from '../providers/config-provider';
import { UtilProvider } from '../providers/util-provider';

import { Url } from '../models/url.model';
import { Banner } from '../models/banner.model';

@Injectable()
export class GeralProvider {

    public params = new URLSearchParams();
    public urlGeral = new Url
    public headers: Headers;
    public options: RequestOptions;


    constructor(public http: Http,
        public jsonp: Jsonp,
        public configProvider: ConfigProvider) {
        this.urlGeral = configProvider.url;

        this.headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': this.urlGeral.SgunAuthorization, 'MobileReferer': this.urlGeral.SgunReferer });
        this.options = new RequestOptions({ headers: this.headers });

        this.params.set('format', 'json');
        this.params.set('callback', this.configProvider.CALLBACK);
    }

    getBanners(congressoAno): Promise<Banner> {
        let param = this.params;
        param.set('congressoAno', <any>congressoAno);
        return this.jsonp.get(this.urlGeral.Cientifico + '/shared/apc/getBannersTopo.ashx', { search: param })
            .map(res => res.json()).toPromise()
            .then(data => {
                if (data) {
                    return data.resposta.retorno as Banner;
                }

            });
    }
        



}


// WEBPACK FOOTER //
// ./src/providers/geral-provider.ts